import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExclamationMark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 4 12",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.83408 0H0.166016L0.255005 3.37474L0.875504 8.406H3.12459L3.74509 3.37474L3.83408 0ZM1.45309 3.28526L1.39809 1.2H2.60202L2.54701 3.28526L2.06351 7.206H1.93658L1.45309 3.28526ZM1.16345 11.7462C1.41112 11.9117 1.70229 12 2.00015 12C2.39955 12 2.78262 11.8413 3.06505 11.5589C3.34749 11.2765 3.50615 10.8934 3.50615 10.494C3.50615 10.1961 3.41783 9.90497 3.25235 9.65732C3.08687 9.40966 2.85164 9.21663 2.57646 9.10265C2.30127 8.98865 1.99846 8.95882 1.70634 9.01695C1.41422 9.07505 1.14586 9.21848 0.935242 9.4291C0.724625 9.63972 0.581192 9.90807 0.523087 10.2002C0.464966 10.4923 0.494797 10.7951 0.608765 11.0703C0.722763 11.3455 0.915802 11.5807 1.16345 11.7462ZM1.80013 10.1947C1.85934 10.1551 1.92894 10.134 2.00015 10.134C2.09561 10.134 2.18718 10.1719 2.25468 10.2394C2.32222 10.3069 2.36015 10.3985 2.36015 10.494C2.36015 10.5652 2.33902 10.6348 2.29947 10.694C2.25992 10.7532 2.20369 10.7994 2.13791 10.8266C2.07213 10.8538 1.99974 10.861 1.92992 10.8471C1.86008 10.8332 1.79593 10.7989 1.74557 10.7486C1.69525 10.6982 1.66095 10.6341 1.64706 10.5642C1.63316 10.4944 1.64029 10.422 1.66756 10.3562C1.69479 10.2905 1.74095 10.2342 1.80013 10.1947Z"
	})]
});
const ForwardRef = forwardRef(SvgExclamationMark);
export default ForwardRef;
